<div class="viet-qr-comp-wrapper">
  <app-header></app-header>
  <div class="body-wrapper">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 mb-4">
          <div class="col-wrapper">
            <div class="title">
              <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/method-icon.svg" alt="" width="auto"
                height="auto" />
              <span>Mã QR</span>
            </div>
            <div class="viet-qr-container">
              <div class="top-item">
                <h4>Giao dịch kết thúc trong</h4>
                <div class="countdown-timer">
                  <span>{{ minutes }}</span>:<span>{{ seconds }}</span>
                </div>
              </div>
              <div class="bottom-item">
                <div class="qr-code">
                  <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/Qrcode_sample.png" alt="" width="auto" height="auto" />
                  <span>Dùng ứng dụng ngân hàng để thanh toán</span>
                </div>
                <div class="button-container">
                  <button (click)="downloadImage('https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/Qrcode_sample.png')">
                    <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/save_img.svg" alt="" width="auto"
                      height="auto" />
                    <span>Lưu ảnh</span>
                  </button>
                  <button>
                    <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/Share.svg" alt="" width="auto"
                      height="auto" />
                    <span>Chia sẻ</span>
                  </button>
                  <button>
                    <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/info-circle.svg" alt="" width="auto"
                      height="auto" />
                    <span>Hướng dẫn</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="col-wrapper">
            <div class="title">
              <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/method-icon.svg" alt="" width="auto"
                height="auto" />
              <span>Chi tiết thanh toán</span>
            </div>
            <div class="item d-flex align-items-center" *ngIf="paymentInfo?.addition_price > 0">
              <div class="left">
                <div class="item-title">
                  <span class="position-relative">
                    Tiền cước internet bổ sung
                    <div class="tool-tip-payment" *ngIf="showTooltip" (clickOutside)="showTooltip = false"
                      [exclude]="'.open-tooltip'">
                      <h2>Cách tính cước Internet bổ sung</h2>
                      <div class="list-item-wrapper">
                        <div class="item-in-list">
                          <div class="title-item">Gói cước hiện tại</div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold">{{
                                paymentInfo?.addition_detail.current_data
                                ?.data_name
                                }}</span>
                            </div>
                            <div>
                              <span class="text-bold">{{
                                paymentInfo?.addition_detail.current_data
                                ?.duration
                                }}
                              </span>
                              {{
                              paymentInfo?.addition_detail.current_data?.time
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="item-in-list">
                          <div class="title-item">Gói cước mới</div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold">{{
                                paymentInfo?.addition_detail.new_data
                                ?.data_name
                                }}
                              </span>
                              ({{
                              paymentInfo?.addition_detail.new_data
                              ?.description
                              }}
                              )
                            </div>
                          </div>
                        </div>
                        <div class="item-in-list">
                          <div class="title-item">Thời điểm tính cước mới</div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold">{{
                                paymentInfo?.addition_detail.t_apply
                                }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="item-in-list">
                          <div class="title-item">
                            Tiền trả trước thu tăng thêm
                          </div>
                          <div class="content-item">
                            <div>
                              <span class="text-bold">{{
                                paymentInfo?.addition_detail.addition_price
                                .fee_str
                                }}
                              </span>
                            </div>
                            <div>
                              {{
                              paymentInfo?.addition_detail.addition_price.time
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                  <a (click)="toggleTooltipPayment()" class="position-relative open-tooltip hide-mobile"
                    *ngIf="paymentInfo?.is_detail">
                    <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/warning-icon.svg" alt="" width="auto"
                      height="auto" />
                  </a>
                  <a (click)="openPopup('tool-tip-payment', paymentInfo)" *ngIf="paymentInfo?.is_detail"
                    class="position-relative open-tooltip show-mobile">
                    <img src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/warning-icon.svg" alt="" width="auto"
                      height="auto" />
                  </a>
                </div>
                <div class="sub-title" *ngIf="paymentInfo?.addition_detail?.addition_price.time">
                  ({{ paymentInfo?.addition_detail?.addition_price.time }})
                </div>
              </div>
              <div class="right">
                {{ swapWifiService.convertPrice(paymentInfo?.addition_price) }}đ
              </div>
            </div>
            <div class="item d-flex align-items-center">
              <div class="left">
                <div class="item-title">Phí chuyển đổi dịch vụ</div>
              </div>
              <div class="right">
                {{ swapWifiService.convertPrice(paymentInfo?.exchange_price) }}đ
              </div>
            </div>
            <div class="item d-flex">
              <div class="left">
                <div class="item-title special">Tổng thanh toán</div>
              </div>
              <div class="right">
                <div class="text">
                  {{ swapWifiService.convertPrice(paymentInfo?.total_price) }}đ
                  <div class="sub-vat">(Đã bao gồm VAT)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
<app-spinner-layout></app-spinner-layout>
